import script from "./Solution.vue?vue&type=script&setup=true&lang=js"
export * from "./Solution.vue?vue&type=script&setup=true&lang=js"

import "./Solution.vue?vue&type=style&index=0&id=2a83f8c0&scoped=true&lang=css"

import exportComponent from "/Users/kellyluo/Work/projects/icheer-web-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a83f8c0"]])

export default __exports__